import BaseModel from './BaseModel';
import crApi from '../service/CrApi';
import securityService from '../service/SecurityService';

export default class ScanModel extends BaseModel {
    public retrieve(params = {}) {
        params['website_token'] = securityService.getToken();
        return crApi.request('scans', 'retrieve', params).then((response) => {
            const result = response.data.xml;
            result.scan = crApi.extractCollection(result.scan);

            for (let scan of result.scan) {
                scan.answer = crApi.extractCollection(scan.answer);
            }

            return result;
        });
    };

    public count(params = {}) {
        params['website_token'] = securityService.getToken();
        return crApi.request('scans', 'count', params).then(function (response) {
            return response.data.xml;

        });
    };

    public retrieveProperties(params = {}) {
        params['website_token'] = securityService.getToken();
        return crApi.request('scans', 'retrieveproperties', params).then((response) => {
            const result = response.data.xml;
            result.property = crApi.extractCollection(result.property);

            return result;
        });
    };

    public retrieveQuestions(params = {}) {
        params['website_token'] = securityService.getToken();
        return crApi.request('scans', 'retrievequestions', params).then((response) => {
            const result = response.data.xml;
            result.question = crApi.extractCollection(result.question);

            for (let question of result.question) {
                question.answer = crApi.extractCollection(question.answer);
            }

            return result;
        });
    };

    public retrieveAnswer(params = {}) {
        params['website_token'] = securityService.getToken();
        return crApi.request('scans', 'retrieveanswers', params).then((response) => {
            const result = response.data.xml;
            result.question = crApi.extractCollection(result.question);

            for (let q of result.question) {
                q.answer = crApi.extractCollection(q.answer);
            }

            return result;
        });
    };

    public securescan(params, answers) {
        params['website_token'] = securityService.getToken();
        params.answerjson = answers;
        return crApi.request('scans', 'securescan', params).then(function (response) {
            return response.data.xml;
        });
    };
}